import React from 'react';
import { getPedidoIngresoOrigenMeta } from '../utils/pedidoIngresoOrigen';

export default function PedidoIngresoOrigenBadge({ origen, conversationId = null, compact = false }) {
  const meta = getPedidoIngresoOrigenMeta(origen);
  if (!meta) return null;
  const convLabel = conversationId ? `Conv. #${conversationId}` : null;
  return (
    <span
      title={meta.title}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: compact ? 5 : 8,
        padding: compact ? '4px 9px' : '6px 12px',
        borderRadius: 999,
        border: '1px solid rgba(14, 165, 233, 0.2)',
        background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 55%, #ecfeff 100%)',
        color: '#0369a1',
        fontSize: compact ? 10 : 11,
        fontWeight: 800,
        letterSpacing: compact ? '0.04em' : '0.03em',
        lineHeight: 1.2,
        boxShadow: '0 2px 6px rgba(14,165,233,.08)',
        whiteSpace: 'nowrap',
        flexShrink: 0
      }}
    >
      <span
        aria-hidden
        style={{
          width: compact ? 6 : 7,
          height: compact ? 6 : 7,
          borderRadius: '50%',
          background: 'linear-gradient(180deg, #38bdf8, #0284c7)'
        }}
      />
      <span style={{ textTransform: 'none' }}>{compact ? meta.short : meta.tag}</span>
      {convLabel ? (
        <span
          style={{
            padding: '2px 7px',
            borderRadius: 999,
            background: '#fff',
            border: '1px solid rgba(148,163,184,0.35)',
            color: '#475569',
            fontSize: 9,
            fontWeight: 700
          }}
        >
          {convLabel}
        </span>
      ) : null}
    </span>
  );
}
